import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import NotificationService from '../../../core/services/NotificationService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import { browserHistory } from 'react-router';

export default class StudentPlacementResetService {
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      studentId: null,
    });
  }

  init = action((studentId) => {
    this.studentId = studentId;
  });

  handleReset = action(() => {
    ConfirmationDialogService.show(
      'New Placement Test',
      "Would you like to allow this student to take a new Placement test? Once he finishes it, the test result will define the student's new course",
      () => {
        this.submit
          .fetch({
            url: `/students/${this.studentId}/reset-placement`,
            method: 'post',
          })
          .then(() => {
            if (this.submit.data) {
              browserHistory.goBack();
              NotificationService.addNotification('Placement test successfully allowed', 'success');
            }
            if (this.submit.error) {
              NotificationService.addNotification('Error to allow the new placement test', 'error');
            }
          });
      }
    );
  });
}
